<template>
  <div>
    <v-tabs v-model="tab" background-color="primary" show-arrows fixed-tabs>
      <v-tab key="courses" class="font-weight-bold">Courses</v-tab>
      <v-tab key="categories" class="font-weight-bold">Categories</v-tab>
      <v-tab key="levels" class="font-weight-bold">Levels</v-tab>
      <v-tab key="certificationBodies" class="font-weight-bold">Awarding Bodies</v-tab>
    </v-tabs>
    <v-tabs-items v-model="tab">
      <v-tab-item key="courses">
        <Courses/>
      </v-tab-item>
      <v-tab-item key="categories">
        <Categories/>
      </v-tab-item>
      <v-tab-item key="levels">
        <Levels/>
      </v-tab-item>
      <v-tab-item key="certificationBodies">
        <CertificationBodies/>
      </v-tab-item>
    </v-tabs-items>
  </div>
</template>

<script>

import Categories from "./Categories";
import CertificationBodies from "./CertificationBodies";
import Levels from "./Levels";
import Courses from "./Courses";
import { mapActions } from "vuex";

export default {
  name: "CourseTab",
  components: {Categories, Courses, Levels, CertificationBodies},
  data() {
    return {
      tab: null,
    };
  },
  methods: {
    ...mapActions(['getAuth']),
  },
  async created() {

    try {
      await this.getAuth();
    } catch (err) {
      //TODO - Do something with the error and remove console.log
      console.error('error', err);
    }
  },
};
</script>

<style scoped>

</style>
